import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/common/Header';
import LoadingScreen from '../components/common/LoadingScreen';
import Hero from '../components/landing/Hero';
import FormsReimagined from '../components/landing/FormsReimagined';
import WhyEngage from '../components/landing/WhyEngage';
import BuildWithoutLimits from '../components/landing/BuildWithoutLimits';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';
import useLoadingComplete from '../hooks/useLoadingComplete';
import useAuth from '../hooks/useAuth';

const Landing = () => {
  const loading = useLoadingComplete();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Auto-redirect authenticated users to dashboard
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, authLoading, navigate]);

  return (
    <>
      {loading ? (
        <LoadingScreen onComplete={() => {}} />
      ) : (
        <>
          <Header />
          <Hero />
          <FormsReimagined />
          <WhyEngage />
          <BuildWithoutLimits />
          <FinalCTA />
          <Footer />
        </>
      )}
    </>
  );
};

export default Landing;